export const syncUser = async (user,
    getToken,
    post,
    apiUrl) => {
    try {
        const access_token = await getToken();
        if (access_token) {
            const user_id = user?.sub?.split("|")[1];
            const userData = {
                "user_id": user_id,
                "firstname": user?.given_name,
                "lastname": user?.family_name,
                "email": user?.email,
                "created_at": new Date(),
                "updated_at": new Date()
            };
            await post(apiUrl, { id: user_id, userData: userData }, access_token);
        }
    } catch (err) {
        console.error("User sync failed", err);
    }
};